
import React from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import './App.css';

import Header from './components/Header';
import MobileHeader from './components/MobileHeader';
import Home from './components/Home';
import Bio from './components/Bio';
import Events from './components/Events';
import Videos from './components/Videos';
import Contact from './components/Contact';
import Footer from "./components/Footer";
import AdminMedia from "./components/AdminMedia";
import AdminPanel from "./components/AdminPanel";
import AdminEvents from "./components/AdminEvents";
import AdminContact from "./components/AdminContactMessages";

import LegalNotice from "./components/LegalNotice";
import PrivacyPolicy from "./components/PrivacyPolicy";
import CookiesPolicy from "./components/CookiesPolicy";

import CookieBanner from "./components/CookieBanner";

import "./styles/AdminEvents.css";


function App() {
  return (
    <div className="layout">
      <Router>
        <Header />
        <MobileHeader />
        <div className="app-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/bio" element={<Bio />} />
            <Route path="/events" element={<Events />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/admin/media" element={<AdminMedia />} />
            <Route path="/admin/events" element={<AdminEvents />} />
            <Route path="/admin/contact" element={<AdminContact />} />
            <Route path="/legal-notice" element={<LegalNotice />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookies-policy" element={<CookiesPolicy />} />
          </Routes>
        </div>
        <Footer />
        <CookieBanner />
      </Router>
    </div>
  );
}

export default App;
